import { render, staticRenderFns } from "./TicketsReply.vue?vue&type=template&id=bcbcdd06&scoped=true"
import script from "./TicketsReply.vue?vue&type=script&lang=js"
export * from "./TicketsReply.vue?vue&type=script&lang=js"
import style0 from "./TicketsReply.vue?vue&type=style&index=0&id=bcbcdd06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbcdd06",
  null
  
)

export default component.exports